import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'form-button',
  standalone: false,
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss']
})
export class FormButtonComponent implements OnInit, OnChanges {
  @Input() formButton: FormButton;
  @Input() isDisabled: boolean;
  @Input() type: string;
  @Output() click: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
  }

  onClickEvent() {
    if (!this.isDisabled && !this.formButton.isSubmitting) {
      this.click.emit();
    }
  };
}

export class FormButton {
  ButtonText: string = '';
  ButtonIcon: string = '';
  ButtonStatus: string = '';
  ErrorMessage: string = '';
  isSubmitting: boolean = false;
  resetText: string = '';
  resetIcon: string = '';

  constructor(text: string, icon: string = 'more_horiz') {
    this.resetText = text;
    this.resetIcon = icon;
    this.setDefault();
  }

  setDefault() {
    this.isSubmitting = false;
    this.ButtonStatus = 'disabled';
    this.ButtonText = this.resetText;
    this.ButtonIcon = this.resetIcon;
    this.ErrorMessage = undefined;
  }

  setSubmit(text: string) {
    this.isSubmitting = true;
    this.ButtonText = text;
    this.ButtonStatus = 'submitting';
    this.ButtonIcon = 'refresh';
    this.ErrorMessage = undefined;
  }

  setSuccess(text: string) {
    this.isSubmitting = false;
    this.ButtonStatus = 'disabled';
    this.ButtonText = text;
    this.ButtonIcon = 'check';
    this.ErrorMessage = undefined;
  }

  setError(text: string, error: string) {
    this.ButtonText = text;
    this.ButtonIcon = 'warning';
    this.ButtonStatus = 'error';
    this.ErrorMessage = error;
    this.isSubmitting = false;
  }
}
